import React from 'react';
import { TextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material/TextField';
import theme from 'theme';

const styles = {
    root: {
        flexGrow: 1,
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        padding: 0,
        margin: 0,
        '& .MuiOutlinedInput-root': {
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
            borderRadius: '15px',
            flex: 1,
            flexDirection: 'column',
        },
    },
};

export default function TextArea(props: TextFieldProps) {
    return (
        <TextField
            sx={styles.root}
            multiline={props.multiline ?? true}
            variant={props.variant ?? 'outlined'}
            {...props}
        />
    );
}
